export default function scrollIntoView(element, options = {}) {
  const scrollPromise = new Promise((resolve) => {
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      ...options,
    });

    // Listen for the end of scroll animation
    const checkScrollEnd = setInterval(() => {
      if (window.scrollY === element.offsetTop) {
        clearInterval(checkScrollEnd);
        resolve();
      }
    }, 100);

    // Fallback timeout after 1 second
    setTimeout(() => {
      clearInterval(checkScrollEnd);
      resolve();
    }, 1000);
  });

  return scrollPromise;
}
